import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activations',
  templateUrl: './activations.component.html',
  styleUrls: ['./activations.component.scss']
})
export class ActivationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
